document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("survey-form");
  const submitButton = document.getElementById("survey-submit-btn");

  const emailInput = document.getElementById("survey_email");
  const mobileInput = document.getElementById("survey_mobile");
  const dobInput = document.getElementById("survey_dob");
  const questionFieldsets = document.querySelectorAll("fieldset[data-question-id]");
  const popupWrapper = document.querySelector(".survey-popup-wrapper");
  const closePopupBtn = document.querySelector(".close-survey-popup");

  const emailError = document.querySelector(".survey-email-error-message");
  const mobileError = document.querySelector(".survey-mobile-error-message");
  const submitError = document.querySelector(".survey-submit-error-message");

  const scriptURL = "https://script.google.com/macros/s/AKfycbyQ4VB8fHiuW9z5CJBs7CCo2JEYnbqIhZcPILLHtHfw3gG49yq9FNm0OGrTpkUG9m7t/exec";

  submitButton.disabled = true;

  if (closePopupBtn) {
    closePopupBtn.addEventListener("click", () => {
      popupWrapper.classList.add("popup-hidden");
    });
  }

  function validateEmailInput() {
    const value = emailInput.value.trim();
    const pattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    return value !== "" && pattern.test(value);
  }

  function validateMobileInput() {
    const value = mobileInput.value.trim();
    const pattern = /^[6-9]\d{9}$/;
    return pattern.test(value);
  }

  function validateForm() {
    const isEmailValid = validateEmailInput();
    const isMobileValid = validateMobileInput();
    const isDOBValid = dobInput.value.trim() !== "";

    let allQuestionsAnswered = true;
    questionFieldsets.forEach(fieldset => {
      const checked = fieldset.querySelector("input[type='radio']:checked");
      if (!checked) {
        allQuestionsAnswered = false;
      }
    });

    submitButton.disabled = !(isEmailValid && isMobileValid && isDOBValid && allQuestionsAnswered);
  }

  [emailInput, mobileInput, dobInput].forEach(input => {
    input.addEventListener("input", validateForm);
  });

  questionFieldsets.forEach(fieldset => {
    const radios = fieldset.querySelectorAll("input[type='radio']");
    radios.forEach(radio => radio.addEventListener("change", validateForm));
  });

  // Blur Event for Email
  emailInput.addEventListener("blur", () => {
    if (!validateEmailInput()) {
      emailError.textContent = "Please enter a valid email address.";
      submitError.textContent = "Please fill in all required fields correctly before submitting the form.";
    } else {
      emailError.textContent = "";
      if (validateMobileInput()) {
        submitError.textContent = "";
      }
    }
  });

  // Blur Event for Mobile
  mobileInput.addEventListener("blur", () => {
    if (!validateMobileInput()) {
      mobileError.textContent = "Mobile number must be 10 digits and start with 6, 7, 8, or 9.";
      submitError.textContent = "Please fill in all required fields correctly before submitting the form.";
    } else {
      mobileError.textContent = "";
      if (validateEmailInput()) {
        submitError.textContent = "";
      }
    }
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

     // Disable submit button immediately to prevent multiple clicks
    submitButton.disabled = true;

    // Activate loader
    submitButton.querySelector(".loading-overlay").style.opacity = "1";
    submitButton.querySelector(".survey-submit-text").style.opacity = "0";

    const email = emailInput.value.trim();
    const mobile = mobileInput.value.trim();
    const dob = dobInput.value.trim();

    const formData = new URLSearchParams();
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("dob", dob);

    questionFieldsets.forEach(fieldset => {
      const index = fieldset.dataset.questionId;
      const selected = fieldset.querySelector("input[type='radio']:checked");
      if (selected) {
        formData.append(`question_${index}`, selected.value);
      }
    });

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData
      });

      const result = await response.json();

      // Hide loader
      submitButton.querySelector(".loading-overlay").style.opacity = "0";
      submitButton.querySelector(".survey-submit-text").style.opacity = "1";

      if (result.result === "success") {
        // Step 1: Extract values BEFORE form reset
        const answers = {};
        questionFieldsets.forEach(fieldset => {
          const index = fieldset.dataset.questionId;
          const selected = fieldset.querySelector("input[type='radio']:checked");
          if (selected) {
            answers[`question_${index}`] = selected.value;
          }
        });

        // Step 2: Reset form and UI
        popupWrapper.classList.remove("popup-hidden");
        form.reset();
        submitButton.disabled = true;

        // Clear all error messages
        emailError.textContent = "";
        mobileError.textContent = "";
        submitError.textContent = "";

        // Step 3: Send MoEngage Event
        if (typeof Moengage !== "undefined") {
          Moengage.add_email( email );
          Moengage.add_mobile( mobile );
          Moengage.add_unique_user_id( email );
          Moengage.add_first_name( email.split("@")[0] );
          Moengage.add_user_attribute("DOB", dob);
          Moengage.add_user_attribute("Mobile Number (Standard)", mobile );
          Moengage.add_user_attribute("Registered Via", "Customer Survey");

          Moengage.track_event("Survey submit", {
            "Email": email,
            "Mobile": mobile,
            "DOB": dob,
            ...answers,
            "Device": navigator.userAgent,
            "Source": "Shopify",
            "Brand": "Birkenstock"
          });
        }
  } else if (result.result === "error") {
        if (result.reason === "email") {
          emailError.textContent = "This email address has already been registered.";
          mobileError.textContent = "";
          submitError.textContent = "Please fill in all required fields correctly before submitting the form.";
        } else if (result.reason === "mobile") {
          mobileError.textContent = "This mobile number is already in use.";
          emailError.textContent = "";
          submitError.textContent = "Please fill in all required fields correctly before submitting the form.";
        } else if (result.reason === "both") {
          emailError.textContent = "This email address has already been registered.";
          mobileError.textContent = "This mobile number is already in use.";
          submitError.textContent = "This email and mobile number have already been used to submit the survey.";
        } else {
          submitError.textContent = "An unexpected error occurred.";
        }
      }

    } catch (error) {
      submitError.textContent = "Unable to connect. Please check your network and retry.";

      // Hide loader
      submitButton.querySelector(".loading-overlay").style.opacity = "0";
      submitButton.querySelector(".survey-submit-text").style.opacity = "1";
    }
  });
});
